export default "/img/chat/typing-indicator.svg"